module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("JULY 2006")])]), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Five minutes that matter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Across the desk. The spot beside her, empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know anymore,” she says. “I just don’t know.” Presses her palms into her temples, hoping her head doesn’t explode.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you decide,” the woman says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is their secret.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c37972e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 78
// module chunks = 0